import React from 'react';
import { PromptConfirmation } from 'ui';
import { Switch } from 'ui/common/switch/switch';
import { LinkCodesTranslation } from '../constants';
import { useDetailsCallbacks, usePromptOnChange } from '../hooks';

interface ListHeaderSwitchProps {
  className: string;
  hasChanges: boolean;
  includeInactive: boolean;
  translation: LinkCodesTranslation;
}

export const ListHeaderSwitch: React.FC<ListHeaderSwitchProps> = ({
  className, hasChanges, includeInactive, translation
}) => {

  const { updateIncludeInactive } = useDetailsCallbacks();
  const { displayPrompt, onPromptedChange, onContinue, onHide } = usePromptOnChange(hasChanges, updateIncludeInactive);

  return <>
    {displayPrompt && <PromptConfirmation
      title={translation.cancel_changes}
      description={translation.are_you_sure}
      continueText={translation.undo_all}
      cancelText={translation.go_back}
      onContinue={onContinue}
      onCancel={onHide} />}
    {translation.show_inactive_codes}
    <Switch
      className={className}
      checked={includeInactive}
      onChange={onPromptedChange} />
  </>;
};
